import * as React from 'react';

import RootRoutes from './RootRoutes';

import './App.scss';
import { DataEnvironmentProvider } from 'contexts/DataEnvironmentContext';
import { BrowserRouter } from 'react-router-dom';
import Auth from 'components/Auth/Auth';
import DataEnvironmentGuard from 'components/DataEnvironmentGuard/DataEnvironmentGuard';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import Header from 'components/Header';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { GlobalStyle, THEME } from 'Theme';
import { ThemeProvider } from 'styled-components';

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider theme={THEME}>
      <ErrorBoundary>
        <ToastContainer autoClose={5000} hideProgressBar pauseOnHover closeOnClick />
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={true} />

          <DataEnvironmentProvider>
            <BrowserRouter>
              <Auth>
                <DataEnvironmentGuard>
                  <Header />

                  <div className="container-fluid p-0">
                    <div className="container-fluid bg-white p-3">
                      <RootRoutes />
                    </div>
                  </div>
                </DataEnvironmentGuard>
              </Auth>
            </BrowserRouter>
          </DataEnvironmentProvider>
        </QueryClientProvider>
      </ErrorBoundary>
      <GlobalStyle />
    </ThemeProvider>
  );
}

export default App;
